import { Dialog, Tabs } from "../../../../layout";
import React, { useEffect, useState } from "react";
import ProdInv from "./ProdInv";
import ProdDtls from "./ProdDtls";
import { IconButton } from "@mui/material";
import { CloseRounded } from "@mui/icons-material";
import { action, API, controller } from "../../../../api/api";
import VarProdInv from "./VarProdInv";
import CompositProdInv from "./CompositProdInv";
import ProdShortDtls from "./ProdShortDtls";
import StockDetails from "./StockDetails";
import { no_img } from "../../../../assets";

const ViewProd = ({ id, setShowForm }) => {
  const [loading, setLoading] = useState(false);
  const [product, setProduct] = useState({});
  const [showStock, setShowStock] = useState(false);
  const [viewStockProd, setViewStockProd] = useState();
  const [outlets, setOutlets] = useState([]);

  useEffect(() => {
    API(controller.Outlet + action.GetAllByOrg).get((res) => {
      res && res.status === 200 && setOutlets([...res.result]);
    });
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (id) {
      setLoading(true);
      API(controller.Product + action.ProductDetails).getById(id, (res) => {
        res.status === 200 &&
          setProduct({
            ...res.result,
            imgUrl:
              res.result && res.result.imgs[0]
                ? res.result.imgs[0].imgUrl
                : no_img,
          });
        setLoading(false);
      });
    }
    return () => {};
  }, [id]);

  const handleClose = () => {
    setShowForm((j) => !j);
  };

  const handleShowStock = (prod, type) => {
    setViewStockProd({ ...prod, type });
    setShowStock(!showStock);
  };

  const renderInv = (product) => {
    switch (product.prodType) {
      case 1:
        return <ProdInv {...{ product, outlets, handleShowStock }} />;
      case 2:
        return <VarProdInv {...{ product, outlets, handleShowStock }} />;
      case 3:
        return <CompositProdInv {...{ product, outlets, handleShowStock }} />;
      default:
        break;
    }
  };

  return (
    <>
      <div className="flex flex-col max-h-[90vh]">
        {/* ======= Header ======== */}
        <div className="flex justify-between items-center gap-2 border-b p-[5px]">
          <span className="text-[20px] ml-[10px] uppercase text-gray-500 font-medium">
            Product Details
          </span>
          <div>
            <IconButton onClick={handleClose}>
              <CloseRounded />
            </IconButton>
          </div>
        </div>
        {/* ======= Body ======== */}
        <div className="flex-1 overflow-y-auto p-[10px] md:p-[15px] flex flex-col gap-5">
          <div>
            <ProdShortDtls {...{ product, outlets, handleShowStock }} />
          </div>

          {loading ? (
            "Loading..."
          ) : (
            <>
              <div>
                <Tabs header={[{ label: "Inventory" }, { label: "Details" }]}>
                  {renderInv(product)}
                  <ProdDtls {...{ product }} />
                </Tabs>
              </div>
            </>
          )}
        </div>
      </div>

      {/* View Product */}
      {showStock && (
        <Dialog show={showStock} onClose={false} maxWidth="lg">
          <StockDetails
            {...{ setShowForm: setShowStock, product: viewStockProd, outlets }}
          />
        </Dialog>
      )}
    </>
  );
};

export default ViewProd;
